module.exports = __webpack_public_path__ + "68f05c7a3bb04992555d364520e02bba.svg";